import { TElement } from '@udecode/plate';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface SlatePluginsStore {
  members: any[];
  setMembers: (value: SlatePluginsStore['members']) => void;

  editorId: string;
  setEditorId: (id: string) => void;

  currentUser: { email: string; id: string; avatar: string; firstname: string; lastname: string };
  setCurrentUser: (value: SlatePluginsStore['currentUser']) => void;

  uploadImage?: (e: string | ArrayBuffer) => Promise<string>;
  setUploadImage: (func: SlatePluginsStore['uploadImage']) => void;

  assignTask?: (e: {
    taskName: TElement[];
    members?: string[];
    taskId: string;
    dateRange?: [string, string];
    completed?: boolean;
  }) => Promise<boolean>;
  setAssignTask: (func: SlatePluginsStore['assignTask']) => void;

  removeTask?: (e: { taskId?: string }) => Promise<boolean>;
  setRemoveTask: (func: SlatePluginsStore['removeTask']) => void;

  onMentionUser?: (arg: { memberId: string }) => Promise<void>;
  setOnMentionUser: (func: SlatePluginsStore['onMentionUser']) => void;

  hideSelectionTool: boolean;
  setHideSelectionTool: (arg: boolean) => void;
}

export const useSlatePluginsStore = create<
  SlatePluginsStore,
  [['zustand/devtools', SlatePluginsStore]]
>(
  devtools((set) => ({
    members: [],
    editorId: 'default',
    setEditorId: (id) => set((state) => ({ ...state, editorId: id })),
    setMembers: (members) => set((state) => ({ ...state, members: members })),
    currentUser: { email: '', id: '', avatar: '', firstname: '', lastname: '' },
    setCurrentUser: (user) => set((state) => ({ ...state, currentUser: user })),
    setUploadImage: (func: SlatePluginsStore['uploadImage']) =>
      set((state) => ({ ...state, uploadImage: func })),

    setOnMentionUser: (func: SlatePluginsStore['onMentionUser']) =>
      set((state) => ({ ...state, onMentionUser: func })),

    hideSelectionTool: false,
    setHideSelectionTool: (value) => set({ hideSelectionTool: value }),

    setAssignTask: (func: SlatePluginsStore['assignTask']) =>
      set((state) => ({ ...state, assignTask: func })),

    setRemoveTask: (func: SlatePluginsStore['removeTask']) =>
      set((state) => ({ ...state, removeTask: func })),
  }))
);
